module.exports = __webpack_public_path__ + "img/CQ(1).079f49a1.webp";